import drawingAudio from "@/assets/audios/drawing-exercise.m4a";
import { Button } from "@/components/ui/button";
import { ExerciseLayout } from "@/components/ui/exercise-layout";
import MediaPlayer from "@/components/ui/media-player";
import { createFileRoute, Link } from "@tanstack/react-router";
import { FormattedMessage } from "react-intl";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/drawing/",
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "Drawing Exercise - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "drawing.title",
    navbar: {
      showTitle: true,
    },
  }),
});
function RouteComponent() {
  const { referrer, referrerGroup } = Route.useSearch();
  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <div className="flex flex-col space-y-2">
          <Link
            to={"/adults/exercises/drawing/mandala"}
            search={{ referrer, referrerGroup }}
          >
            <Button className="w-full">
              <FormattedMessage id="drawing.startExercise" />
            </Button>
          </Link>
          <Link
            to={"/adults/exercises/drawing/summary"}
            search={{ referrer, referrerGroup }}
          >
            <Button variant="secondary" className="w-full">
              <FormattedMessage
                id="drawing.myDrawings"
                defaultMessage="My Drawings"
              />
            </Button>
          </Link>
        </div>
      }
    >
      <div className="text-small space-y-2">
        <p>
          <FormattedMessage id="drawing.intro" />
        </p>
        <h3 className="text-lg font-medium text-black pt-2">
          <FormattedMessage id="drawing.introTitle" />
        </h3>
        <p>
          <FormattedMessage id="drawing.introDescription1" />
        </p>
        <p>
          <FormattedMessage id="drawing.introDescription2" />
        </p>
      </div>
      <MediaPlayer src={drawingAudio} />
    </ExerciseLayout>
  );
}
